import { Button, HStack, Stack, Text, useDisclosure } from "@chakra-ui/react"
import { Form, Parts, UI } from "components"
import useUser from "hooks/useUser"

export default function Address(){

    const user = useUser()
    const dialog = useDisclosure()

    return(
    <>
    <Parts.Dialog.Profile.Address {...dialog} />
    <UI.Box loading={user.isLoading} h="auto">
        <Text children="Endereço:" size="xs" color="GrayText" mb={4} />

        <Stack gap={4}>

            <Form.Text readOnly label="Endereço (Linha 1):" value={user.data?.address?.line_1} variant="ghost" />
            <Form.Text readOnly label="Endereço (Linha 2):" value={user.data?.address?.line_2} variant="ghost" />

            <HStack>
                <Form.Text readOnly label="País:" value={user.data?.address?.city?.state?.country?.name} variant="ghost" />
                <Form.Text readOnly label="Estado:" value={user.data?.address?.city?.state?.name} variant="ghost" />
                <Form.Text readOnly label="Cidade:" value={user.data?.address?.city?.name} variant="ghost" />
            </HStack>
            
            <HStack>
                <Form.Text readOnly label="CEP:" value={user.data?.address?.zip} variant="ghost" />
                <Form.Text readOnly label="Bairro/Setor:" value={user.data?.address?.neighborhood} variant="ghost" />
            </HStack>

            <HStack>
                <Form.Text readOnly label="Número:" value={user.data?.address?.number} variant="ghost" />
                <Form.Text readOnly label="Complemento:" value={user.data?.address?.complement} variant="ghost" />
            </HStack>

            <Button colorPalette="orange" onClick={dialog.onOpen}><UI.Icon name="edit" /> Alterar endereço</Button>

            <UI.Alert size="sm">Por questões de segurança, o seu endereço só poderá ser alterado por você a cada 90 dias. Caso seja uma situação específica, contate o suporte.</UI.Alert>
        </Stack>
    </UI.Box>
    </>
    )
}